export const createHostnameForEnv = () => {
  const originEnv = process.env.LOCALE_ORIGIN;

  if (originEnv.includes("www.qa.privatefly")) return "www.qa.privatefly"
  else if (originEnv.includes("www.uat.privatefly")) return "www.uat.privatefly"
  else if (originEnv.includes("www.privatefly")) return "www.privatefly"
  else return "www.dev.privatefly"
}